








































import Component from 'vue-class-component';
import Vue from 'vue';
import { format, parse } from 'date-fns';
import {
    findTimeZone,
    getZonedTime,
    getUnixTime,
    convertDateToTime,
    getUTCOffset
} from 'timezone-support';
import { nowEDT } from '@/utils';

@Component({})
export default class TimezoneBlock extends Vue {
    public currentTime: string = '';
    public timerId: any = null;

    public created() {
        this.tick();
    }

    public destroyed() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
    }

    public tick() {
        const nd = nowEDT();
        this.currentTime = format(nd, 'ddd, DD MMM YYYY HH:mm:ss') + ' EDT';
        this.timerId = setTimeout(this.tick, 1000);
    }
}
